import * as React from 'react';
import { Portal } from '../Portal/Portal.js';
import { DrawerBackdrop } from './components/DrawerBackdrop/DrawerBackdrop.js';
import { DrawerCloseButton } from './components/DrawerCloseButton/DrawerCloseButton.js';
import { DrawerContent } from './components/DrawerContent/DrawerContent.js';
import { DrawerDivider } from './components/DrawerDivider/DrawerDivider.js';
import { DrawerHeader } from './components/DrawerHeader/DrawerHeader.js';
import { DrawerOverlay } from './components/DrawerOverlay/DrawerOverlay.js';
import { DrawerTitle } from './components/DrawerTitle/DrawerTitle.js';
import { DrawerProvider } from './context/DrawerContext.js';

const Drawer = ({ children , onClose , direction  })=>{
    const [isOpen, setIsOpen] = React.useState(false);
    return /*#__PURE__*/ React.createElement(DrawerProvider, {
        direction: direction,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        onClose: onClose
    }, children);
};
Drawer.Overlay = DrawerOverlay;
Drawer.Backdrop = DrawerBackdrop;
Drawer.Portal = Portal;
Drawer.Header = DrawerHeader;
Drawer.Content = DrawerContent;
Drawer.Divider = DrawerDivider;
Drawer.Title = DrawerTitle;
Drawer.CloseButton = DrawerCloseButton;

export { Drawer as default };
//# sourceMappingURL=Drawer.js.map
